<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input 
          v-model="section.title" 
          required 
          :error="$root.errorBag.title">
          Title
        </text-input>
      </div>
    </div>  
    <div class="columns">
      <div class="column">
        <markdown-editor
          v-model="section.description" 
          required 
          :error="$root.errorBag.description">
          Description
        </markdown-editor>
        <submit-button :working="storing" @submit="storeSection" class="is-rounded">Store Section</submit-button>
      </div>
    </div>  
  </form>  
</div>  
</template>
<script>
import { createStandardSection } from '@/api/super'

export default {
  data: () => ({
    storing: false,
    section: {
      title: '',
      description: ''
    }
  }),

  methods: {
    storeSection() {
      this.storing = true
      createStandardSection({
        ...this.section,
        standard_id: this.$route.params.standard
      }, ({data}) => {
        this.storing = false
        this.$toast.success('Section created')
        this.$router.push({
          name: 'standard-sections',
          params: {
            standard: this.$route.params.standard
          }
        })
      }, error => {
        this.storing = false
      })
    }
  }
}
</script>